import type { Column } from '@talos/kyoko';
import type { ColDef } from 'ag-grid-community';
import { getPriceGridColumnMarketSelectorValue } from '../hooks/actions/common/getPriceGridColumnMarketSelectorValue';
import { PriceGridRFQActionButton } from '../hooks/actions/rfq/useRFQAction';
import type { PriceGridEntity } from '../PriceGridEntity';
import {
  getPriceGridMarketDataColumnId,
  getSymbolFromRow,
  PRICE_GRID_MARKET_DATA_RFQ_COLUMN_SUFFIX,
  PRICE_GRID_RFQ_COLUMN_WIDTH,
  type PriceGridMarketDataColumnRow,
  type PriceGridMarketDataRendererParams,
} from './priceGridMarketDataColumnUtils';
import { getPriceGridRowActionColumn } from './priceGridRowActionColumn';
import type { PriceGridSecurityMarketDataColumnParams } from './types';

export function getPriceGridRFQColumn(
  column: Column<PriceGridSecurityMarketDataColumnParams, PriceGridMarketDataColumnRow>
): Column<ColDef<PriceGridEntity, PriceGridEntity>, PriceGridMarketDataColumnRow> {
  return getPriceGridRowActionColumn<PriceGridEntity, PriceGridMarketDataColumnRow>({
    colId: getPriceGridMarketDataColumnId(column, PRICE_GRID_MARKET_DATA_RFQ_COLUMN_SUFFIX),
    field: column.field,
    width: PRICE_GRID_RFQ_COLUMN_WIDTH,
    dynamics: column.dynamics,
    cellRenderer: (params: PriceGridMarketDataRendererParams) => {
      const row = params.value;
      const symbol = row ? getSymbolFromRow(column, row) : undefined;
      const onRFQClick = column.params?.onRFQClick;
      const marketSelectorValue = getPriceGridColumnMarketSelectorValue(params);
      if (!row || !symbol || !onRFQClick || column.params?.isRFQSecuritySelectable?.(row.security) === false) {
        return null;
      }

      return (
        <PriceGridRFQActionButton
          data={row}
          symbol={symbol}
          orderQty={row.bucket.size}
          marketSelectorValue={marketSelectorValue}
          onRFQClick={onRFQClick}
        />
      );
    },
  });
}
